export default __webpack_public_path__ + "assets/icons/pdf.b4ee8c05.svg";